import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 4,
    zIndex: theme.zIndex.drawer - 1,
    border: '1px solid #d5d5d5',
    height: 30,
    lineHeight: '30px',
    padding: '0px 6px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
  },
  isAddIcon: {
    border: `1px solid ${theme.palette.primary.main}`,
    '& svg': { color: theme.palette.primary.main }
  },
  noBorder: {
    border: 'none',
    position: 'static',
    '& svg': { color: theme.palette.primary.dark }
  },
  fullwidth: {
    width: '90%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  button: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      justifyContent: 'center'
    }
  },
  buttonOnShow: {
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: theme.zIndex.drawer - 1,
      width: '100%',
      height: 50,
      backgroundColor: 'white'
    }
  },
  input: {
    borderRadius: 4,

    [theme.breakpoints.down('sm')]: {
      padding: 16
    }
  },
  label: {
    fontSize: 14,
    lineHeight: '30px',
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  icon: {
    color: theme.palette.text.secondary,
    marginRight: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      fontSize: 18
    },
    width: 17
  },
  iconWithNoMargin: {
    marginRight: 0
  },
  filterSelectorPaper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.default,
    padding: 16,
    top: 50,
    left: 0,
    zIndex: theme.zIndex.drawer - 1,
    minWidth: 400,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      position: 'fixed',
      top: 57,
      left: 0,
      zIndex: theme.zIndex.drawer - 1
    }
  },
  filterSelectorPaperForBulkUpdate: {
    left: 0,
    width: '100%',
    top: 0,
    [theme.breakpoints.down('sm')]: {
      minWidth: 400,
      position: 'fixed',
      top: 57,
      left: 0,
      zIndex: theme.zIndex.drawer - 1
    }
  },
  formsContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      paddingRight: 16,
      width: '100%'
    }
  },
  itemsContainer: {
    maxHeight: 300,
    overflowY: 'auto',
    marginTop: 12,
    marginRight: 16,
    marginLeft: 16
  },
  menuItem: {
    borderBottom: '1px solid #e9e9e9',
    width: '100%',
    '&:hover': {
      backgroundColor: theme.palette.grey[400]
    }
  },
  activeMenuItem: {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.grey[400]
    }
  },
  iconbutton: {
    height: 11,
    width: 11,
    marginLeft: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      fontSize: 18
    }
  },
  doneButton: {
    height: 30,
    marginLeft: 12,
    paddingLeft: 24,
    marginTop: 10,
    paddingRight: 24,
    width: 'calc(100% - 20px)',
    [theme.breakpoints.down('sm')]: {
      width: '89%',
      marginLeft: -15,
      marginBottom: 15
    }
  },
  centerModal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%'
  }
}))

export default useStyles
